import { useId } from 'react'
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg'

type AppIconSwapBoldProps = {
  size?: number
}

export function AppIconSwapBold({ size = 20 }: AppIconSwapBoldProps) {
  const id = useId()

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        fill={`url(#${id})`}
        d="M5.76694 19.2855V7.13142L3.97489 8.85037C3.49808 9.30769 2.75111 9.28096 2.30644 8.7906C1.86181 8.30017 1.8878 7.53187 2.36454 7.0745L5.47457 4.09196L5.63413 3.9525C6.45765 3.30568 7.6496 3.35259 8.42042 4.09196L11.5304 7.0745C12.0072 7.53187 12.0332 8.30017 11.5886 8.7906C11.1439 9.28096 10.3969 9.30769 9.9201 8.85037L8.12805 7.13142V19.2855C8.12805 19.9561 7.5995 20.4998 6.9475 20.4998C6.29549 20.4998 5.76694 19.9561 5.76694 19.2855ZM15.8727 4.71427C15.8727 4.04365 16.4012 3.5 17.0532 3.5C17.7052 3.5 18.2338 4.04365 18.2338 4.71427V16.8674L20.0258 15.1494C20.5027 14.6921 21.2496 14.7188 21.6943 15.2091C22.1389 15.6996 22.1129 16.4679 21.6362 16.9252L18.5262 19.9078V19.9087C17.7039 20.6971 16.4025 20.6971 15.5803 19.9087V19.9078L12.4703 16.9252C11.9935 16.4679 11.9675 15.6996 12.4122 15.2091C12.8568 14.7188 13.6038 14.6921 14.0806 15.1494L15.8727 16.8674V4.71427Z"
      />
      <Defs>
        <LinearGradient id={id} x1="1.98926" y1="-12.6312" x2="16.4112" y2="30.6877" gradientUnits="userSpaceOnUse">
          <Stop offset="0.16" stopColor="#7BB6FD" />
          <Stop offset="0.973693" stopColor="#0C75F7" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}
